module.exports = __webpack_public_path__ + "1024b882784d7c593d8a08dcfaa37452.png";